export default function SamverkanModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div
        className="relative w-full max-w-5xl max-h-[90vh] overflow-y-auto bg-white rounded-[2rem] shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >

        {/* Close */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-5 right-5 z-10 w-11 h-11 rounded-full bg-black text-white flex items-center justify-center hover:scale-105 transition"
          aria-label="Stäng"
        >
          ×
        </button>

        {/* CONTENT */}
        <div className="p-8 md:p-12 lg:p-16">

          {/* INTRO */}
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-black/50 mb-3">
            03 · Metodbeskrivningen
          </p>

          <h2 className="text-3xl md:text-4xl font-semibold text-[#222] mb-12 max-w-3xl">
            Hur samverkan etableras och utvecklas över tid
          </h2>

          {/* VARFÖR */}
          <section className="mb-12">
            <p className="text-sm font-semibold uppercase tracking-[0.12em] text-black/45 mb-2">
              Varför är detta viktigt?
            </p>

            <h3 className="text-2xl font-semibold text-[#222] mb-5">
              När flera verksamheter behöver hänga ihop
            </h3>

            <p className="text-[#555] leading-relaxed mb-4">
              Målgruppen har ofta kontakt med flera olika verksamheter
              samtidigt. För att stödet ska bli sammanhållet behöver de
              aktörer som möter individen ha en gemensam förståelse för
              uppdraget och ett fungerande samarbete.
            </p>

            <p className="text-[#555] leading-relaxed">
              Hållbar samverkan handlar inte om att sudda ut organisationernas
              olika uppdrag. Tvärtom bygger den på att varje aktör tar ansvar
              för sitt uppdrag samtidigt som man ser hur de olika delarna
              tillsammans kan skapa ett bättre stöd för individen.
            </p>
          </section>

          {/* HUR ARBETAR VI */}
          <section className="mb-12 pt-10 border-t border-black/10">
            <p className="text-sm font-semibold uppercase tracking-[0.12em] text-black/45 mb-2">
              Hur arbetar vi?
            </p>

            <h3 className="text-2xl font-semibold text-[#222] mb-5">
              Relationer och tillit före rutiner
            </h3>

            <p className="text-[#555] leading-relaxed mb-4">
              Samverkan utvecklas stegvis och behöver ges tid att växa.
              Under utvecklingen av Räkna med mig har vi lagt stor vikt vid
              att skapa relationer, bygga tillit och öka förståelsen för
              varandras uppdrag innan vi utvecklat gemensamma rutiner och
              arbetssätt.
            </p>

            <p className="text-[#555] leading-relaxed mb-4">
              Gemensamma möten, återkommande dialog och ett öppet
              erfarenhetsutbyte har varit viktiga för att skapa samsyn och
              ett gemensamt ansvar för målgruppen. Genom att tillsammans
              analysera utmaningar och utveckla lösningar har samverkan
              successivt gått från att vara personberoende till att bli en
              del av verksamheternas gemensamma struktur.
            </p>

            <p className="text-[#555] leading-relaxed">
              Vi har också arbetat aktivt för att involvera både chefer och
              medarbetare i utvecklingsarbetet. När samverkan finns på flera
              nivåer i organisationerna blir den mindre sårbar vid
              personalförändringar och lättare att utveckla över tid.
            </p>
          </section>

          {/* VAD HAR VI LÄRT OSS */}
          <section className="mb-12 pt-10 border-t border-black/10">
            <p className="text-sm font-semibold uppercase tracking-[0.12em] text-black/45 mb-2">
              Vad har vi lärt oss?
            </p>

            <h3 className="text-2xl font-semibold text-[#222] mb-5">
              Samverkan behöver vårdas över tid
            </h3>

            <p className="text-[#555] leading-relaxed mb-4">
              Vi har lärt oss att hållbart samarbete initialt bygger mer på
              relationer än på rutiner. Gemensamma överenskommelser och
              strukturer får större genomslag när det finns tillit och
              förståelse mellan de personer som ska arbeta utifrån dem.
            </p>

            <p className="text-[#555] leading-relaxed mb-4">
              Vi har också lärt oss att samverkan behöver vårdas
              kontinuerligt. Förändringar i organisationer, nya medarbetare
              och förändrade uppdrag gör att relationer och gemensam kunskap
              behöver byggas upp om och om igen.
            </p>

            <p className="text-[#555] leading-relaxed">
              En annan viktig erfarenhet är att samverkan blir mer hållbar
              när ansvaret delas av flera personer och flera nivåer i
              organisationen. På så sätt minskar sårbarheten och arbetssättet
              blir mindre beroende av enskilda individer.
            </p>
          </section>

          {/* REFLEKTION */}
          <section className="pt-10 border-t border-black/10">
            <p className="text-sm font-semibold uppercase tracking-[0.12em] text-black/45 mb-2">
              Reflektion
            </p>

            <div className="mt-6 p-5 rounded-2xl bg-[#f5f3ef]">
              <p className="text-lg font-semibold text-[#222] leading-relaxed">
                Hållbar samverkan skapas inte genom ett undertecknat avtal.
                Den växer fram när människor lär känna varandras uppdrag,
                bygger förtroende och tillsammans tar ansvar för den
                gemensamma målgruppen.
              </p>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
}